import { useCallback, useState } from 'react';
import { useAppContext } from '../context/context';
import instanceAxios from '../util/axios';

type Result<T = any> = {
  data: T | null;
  error: any;
  loading: boolean;
  fetchData: (payload: Payload) => Promise<T>;
  setDataResult: (data: T) => void;
};

type Payload<E = any> = {
  data?: E;
  url: string;
  method: string;
};

export const useFetch = <T = any, E = any>(defaultLoading = false): Result<T> => {
  const [data, setDataResult] = useState<T | null>(null);
  const [loading, seLoading] = useState(defaultLoading);
  const [error, setError] = useState<unknown>(null);
  const { setSnackbar } = useAppContext();

  const fetchData = useCallback(
    async (request: Payload<E>) => {
      seLoading(true);

      const { url, method, data: dataReuest } = request;
      const payload: Payload = { url, method };

      if (dataReuest) {
        payload.data = dataReuest;
      }

      try {
        const response = await instanceAxios(payload);
        setDataResult(response.data);
        return response.data;
      } catch (err: any) {
        setError(err);
        setSnackbar({ message: 'שגיאה בעת טעינת נתונים', severity: 'error', open: true });
        throw err;
      } finally {
        seLoading(false);
      }
    },
    [setSnackbar]
  );

  return { data, setDataResult, error, loading, fetchData };
};
